import script from "./CourseIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__